import React, { useState } from "react";
import { Play, ArrowRight, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrecisionDemolitionRapidHauling() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  return <section data-section-id="29951" id="cash-for-junk-cars-bc-instant-quotes" className="dark bg-background text-foreground relative overflow-hidden min-h-[85vh] flex flex-col lg:flex-row">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-10 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]"></div>

      {}
      <div className="relative z-10 w-full lg:w-[60%] flex flex-col justify-center px-6 py-16 lg:px-16 xl:px-24">
        <div ref={textRef} className={`transition-all duration-1000 ease-out transform ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-bold tracking-wider uppercase mb-6">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
            Top Rated Scrap Removal in BC
          </div>

          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black tracking-tighter leading-[0.9] mb-8 text-white">
            CASH FOR <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-emerald-400">
              JUNK CARS.
            </span>
            <br />
            FREE PICKUP <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
              INSTANT PAY.
            </span>
          </h1>

          <p className="text-lg text-muted-foreground max-w-xl mb-10 leading-relaxed border-l-4 border-primary/50 pl-6">
            Junk Car Pick Up BC offers the fastest way to turn your unwanted vehicle into immediate cash. 
            We provide free towing and eco-friendly recycling across the entire Lower Mainland, 
            ensuring you get top dollar with zero hassle.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
            <Button asChild size="lg" className="h-14 px-8 text-base font-bold uppercase tracking-wide shadow-[0_0_20px_rgba(132,255,0,0.3)] hover:shadow-[0_0_30px_rgba(132,255,0,0.5)] transition-all duration-300">
              <Link to="/ContactPage">
                Get My Cash Quote <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>

            <Dialog open={isVideoOpen} onOpenChange={setIsVideoOpen}>
              <DialogTrigger asChild>
                
              </DialogTrigger>
              <DialogContent className="sm:max-w-4xl bg-black/95 border-white/10 p-0 overflow-hidden">
                <DialogHeader className="sr-only">
                  <DialogTitle>Our Removal Process</DialogTitle>
                  <DialogDescription>Video showing Junk Car Pick Up BC in action.</DialogDescription>
                </DialogHeader>
                <div className="aspect-video w-full bg-neutral-900 flex items-center justify-center relative group">
                  {}
                  <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581925/img/image_qkayrp15.jpg)] bg-cover bg-center opacity-50"></div>
                  <div className="z-10 flex flex-col items-center gap-4">
                    <div className="w-20 h-20 rounded-full bg-primary/90 flex items-center justify-center shadow-2xl shadow-primary/40 cursor-pointer hover:scale-110 transition-transform">
                      <Play className="h-8 w-8 text-white fill-white ml-1" />
                    </div>
                    <p className="text-white font-bold tracking-widest uppercase text-sm">Play Video</p>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          </div>

          <div className="mt-12 flex flex-wrap gap-6 text-sm font-medium text-muted-foreground/80">
            {["Licensed & Insured", "Eco-Friendly Recycling", "Same-Day Pickup"].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-2">
                <CircleCheck className="h-4 w-4 text-primary" />
                {item}
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="relative w-full lg:w-[40%] min-h-[50vh] lg:min-h-auto overflow-hidden">
        <div ref={imageRef} className={`absolute inset-0 w-full h-full transition-all duration-1000 delay-300 ease-out transform ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-20"}`}>
          {}
          <div className="absolute inset-0 w-full h-full lg:[clip-path:polygon(15%_0,100%_0,100%_100%,0%_100%)] z-10 bg-background">
             <div className="relative w-full h-full overflow-hidden">
                <div className="absolute inset-0 bg-primary/10 mix-blend-overlay z-10"></div>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581925/img/image_qkayrp15.jpg" alt="Modern flatbed tow truck ready for vehicle pickup" className="w-full h-full object-cover object-center scale-125 hover:scale-150 transition-transform duration-700 ease-in-out" />
                
                {}
                <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-black/90 via-black/50 to-transparent z-20 lg:pl-24">
                  <div className="border-l-2 border-primary pl-4">
                    <p className="text-white font-bold text-lg">Same-Day Pickup</p>
                    <p className="text-primary text-sm font-mono">Vancouver & Lower Mainland</p>
                  </div>
                </div>
             </div>
          </div>
          
          {}
          <div className="hidden lg:block absolute top-10 left-0 w-32 h-32 border-t-2 border-l-2 border-primary/30 -translate-x-1/2"></div>
        </div>
      </div>
    </section>;
}